export const roleList = [
  {
    label: 'startsidan',
    name: 'dashboard',
    path: '/',
    allowedAccess: ['all'],
  },
  {
    label: 'Användare',
    name: 'UsersPage',
    path: '/anvandare',
    icon: 'faUser',
    allowedAccess: [
      'Företagsledare',
      'Ordförande BRF',
      'Personalansvarig HR ansvarig',
      'Huvudkontaktperson',
    ],
  },
  {
    label: 'Faktureringsinformation',
    name: 'BillingInfo',
    path: '/faktureringsinformation',
    icon: 'faReceipt',
    allowedAccess: [
      'Företagsledare',
      'Ordförande BRF',
      'Personalansvarig HR ansvarig',
      'Uppgiftslämnare lönesummor antal anställda',
      'Huvudkontaktperson',
    ],
  },
  {
    label: 'Antal anställda',
    name: 'AgreementPage',
    path: '/antal-anstallda',
    icon: '',
    allowedAccess: [
      'Företagsledare',
      'Ordförande BRF',
      'Personalansvarig HR ansvarig',
      'Uppgiftslämnare lönesummor antal anställda',
    ],
  },
  {
    label: 'Garantibelopp',
    name: 'GuaranteedAmountPage',
    path: '/garanibelopp',
    icon: 'faInfoCircle',
    allowedAccess: [
      'Företagsledare',
      'Ordförande BRF',
      'Personalansvarig HR ansvarig',
      'Uppgiftslämnare lönesummor antal anställda',
    ],
  },

  {
    label: 'Lönestatistik',
    name: 'StatisticsPage',
    path: '/lonestatistik',
    icon: '',
    allowedAccess: [
      'Företagsledare',
      'Personalansvarig HR ansvarig',
      'Uppgiftslämnare för lönestatistik',
      'Ordförande BRF',
    ],
  },
  {
    label: 'Årslönesummor',
    name: 'PayData',
    path: '/arslonesummor',
    icon: '',
    allowedAccess: [
      'Företagsledare',
      'Ordförande BRF',
      'Personalansvarig HR ansvarig',
      'Uppgiftslämnare lönesummor antal anställda',
    ],
  },
]

export const checkAccess = (component, roles) => {
  let access = false
  if (!roles) {
    return access
  }
  roleList.forEach((role) => {
    if (role.name === component) {
      role.allowedAccess.forEach((accessRole) => {
        if (roles.includes(accessRole)) {
          access = true
        }
      })
    }
  })
  return access
}
